import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line

const FormField = tw.div`h-20`;
const InputContainer = tw.div`relative mt-6 mb-1 border-b-2 focus-within:border-primary-500`;
const InputField = tw.input`pb-1 font-normal block w-full appearance-none focus:outline-none bg-transparent`;
const InputLabel = tw.label`absolute top-0 -z-1 duration-300 origin-0 text-gray-500 font-medium`;
const Error = tw.small`text-red-500`;

const Input = ({ name, label, error, ...rest }) => {
  return (
    <FormField>
      <InputContainer>
        <InputField
          name={name}
          id={name}
          placeholder=" "
          {...rest}
        ></InputField>
        <InputLabel htmlFor={name}>{label}</InputLabel>
      </InputContainer>
      {error && <Error>{error}</Error>}
    </FormField>
  );
};

export default Input;
